var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line-wrap"},[_c('div',{staticClass:"line-text",class:{ 'no-text': !_vm.text }},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }